export const DATA = {
    callingCodes: [
        { text: '+972', value: '+972' },
        { text: '+93', value: '+93' },
        { text: '+355', value: '+355' },
        { text: '+213', value: '+213' },
        { text: '+1 684', value: '+1 684' },
        { text: '+376', value: '+376' },
        { text: '+244', value: '+244' },
        { text: '+1 264', value: '+1 264' },
        { text: '+1268', value: '+1268' },
        { text: '+54', value: '+54' },
        { text: '+374', value: '+374' },
        { text: '+297', value: '+297' },
        { text: '+61', value: '+61' },
        { text: '+43', value: '+43' },
        { text: '+994', value: '+994' },
        { text: '+1 242', value: '+1 242' },
        { text: '+973', value: '+973' },
        { text: '+880', value: '+880' },
        { text: '+1 246', value: '+1 246' },
        { text: '+375', value: '+375' },
        { text: '+32', value: '+32' },
        { text: '+501', value: '+501' },
        { text: '+229', value: '+229' },
        { text: '+1 441', value: '+1 441' },
        { text: '+975', value: '+975' },
        { text: '+387', value: '+387' },
        { text: '+267', value: '+267' },
        { text: '+55', value: '+55' },
        { text: '+246', value: '+246' },
        { text: '+359', value: '+359' },
        { text: '+226', value: '+226' },
        { text: '+257', value: '+257' },
        { text: '+855', value: '+855' },
        { text: '+237', value: '+237' },
        { text: '+1', value: '+1' },
        { text: '+238', value: '+238' },
        { text: '+345', value: '+345' },
        { text: '+236', value: '+236' },
        { text: '+235', value: '+235' },
        { text: '+56', value: '+56' },
        { text: '+86', value: '+86' },
        { text: '+57', value: '+57' },
        { text: '+269', value: '+269' },
        { text: '+242', value: '+242' },
        { text: '+682', value: '+682' },
        { text: '+506', value: '+506' },
        { text: '+385', value: '+385' },
        { text: '+53', value: '+53' },
        { text: '+537', value: '+537' },
        { text: '+420', value: '+420' },
        { text: '+45', value: '+45' },
        { text: '+253', value: '+253' },
        { text: '+1 767', value: '+1 767' },
        { text: '+1 849', value: '+1 849' },
        { text: '+593', value: '+593' },
        { text: '+20', value: '+20' },
        { text: '+503', value: '+503' },
        { text: '+240', value: '+240' },
        { text: '+291', value: '+291' },
        { text: '+372', value: '+372' },
        { text: '+251', value: '+251' },
        { text: '+298', value: '+298' },
        { text: '+679', value: '+679' },
        { text: '+358', value: '+358' },
        { text: '+33', value: '+33' },
        { text: '+594', value: '+594' },
        { text: '+689', value: '+689' },
        { text: '+241', value: '+241' },
        { text: '+220', value: '+220' },
        { text: '+995', value: '+995' },
        { text: '+49', value: '+49' },
        { text: '+233', value: '+233' },
        { text: '+350', value: '+350' },
        { text: '+30', value: '+30' },
        { text: '+299', value: '+299' },
        { text: '+1 473', value: '+1 473' },
        { text: '+1 671', value: '+1 671' },
        { text: '+502', value: '+502' },
        { text: '+224', value: '+224' },
        { text: '+245', value: '+245' },
        { text: '+595', value: '+595' },
        { text: '+509', value: '+509' },
        { text: '+504', value: '+504' },
        { text: '+36', value: '+36' },
        { text: '+354', value: '+354' },
        { text: '+91', value: '+91' },
        { text: '+62', value: '+62' },
        { text: '+964', value: '+964' },
        { text: '+353', value: '+353' },
        { text: '+39', value: '+39' },
        { text: '+1 876', value: '+1 876' },
        { text: '+81', value: '+81' },
        { text: '+962', value: '+962' },
        { text: '+77', value: '+77' },
        { text: '+254', value: '+254' },
        { text: '+686', value: '+686' },
        { text: '+965', value: '+965' },
        { text: '+996', value: '+996' },
        { text: '+371', value: '+371' },
        { text: '+961', value: '+961' },
        { text: '+266', value: '+266' },
        { text: '+231', value: '+231' },
        { text: '+423', value: '+423' },
        { text: '+370', value: '+370' },
        { text: '+352', value: '+352' },
        { text: '+261', value: '+261' },
        { text: '+265', value: '+265' },
        { text: '+60', value: '+60' },
        { text: '+960', value: '+960' },
        { text: '+223', value: '+223' },
        { text: '+356', value: '+356' },
        { text: '+692', value: '+692' },
        { text: '+596', value: '+596' },
        { text: '+222', value: '+222' },
        { text: '+230', value: '+230' },
        { text: '+262', value: '+262' },
        { text: '+52', value: '+52' },
        { text: '+377', value: '+377' },
        { text: '+382', value: '+382' },
        { text: '+1664', value: '+1664' },
        { text: '+212', value: '+212' },
        { text: '+95', value: '+95' },
        { text: '+264', value: '+264' },
        { text: '+674', value: '+674' },
        { text: '+977', value: '+977' },
        { text: '+31', value: '+31' },
        { text: '+599', value: '+599' },
        { text: '+687', value: '+687' },
        { text: '+64', value: '+64' },
        { text: '+505', value: '+505' },
        { text: '+227', value: '+227' },
        { text: '+234', value: '+234' },
        { text: '+683', value: '+683' },
        { text: '+672', value: '+672' },
        { text: '+1 670', value: '+1 670' },
        { text: '+47', value: '+47' },
        { text: '+968', value: '+968' },
        { text: '+92', value: '+92' },
        { text: '+680', value: '+680' },
        { text: '+507', value: '+507' },
        { text: '+675', value: '+675' },
        { text: '+51', value: '+51' },
        { text: '+63', value: '+63' },
        { text: '+48', value: '+48' },
        { text: '+351', value: '+351' },
        { text: '+1 939', value: '+1 939' },
        { text: '+974', value: '+974' },
        { text: '+40', value: '+40' },
        { text: '+250', value: '+250' },
        { text: '+685', value: '+685' },
        { text: '+378', value: '+378' },
        { text: '+966', value: '+966' },
        { text: '+221', value: '+221' },
        { text: '+381', value: '+381' },
        { text: '+248', value: '+248' },
        { text: '+232', value: '+232' },
        { text: '+65', value: '+65' },
        { text: '+421', value: '+421' },
        { text: '+386', value: '+386' },
        { text: '+677', value: '+677' },
        { text: '+27', value: '+27' },
        { text: '+34', value: '+34' },
        { text: '+94', value: '+94' },
        { text: '+249', value: '+249' },
        { text: '+597', value: '+597' },
        { text: '+268', value: '+268' },
        { text: '+46', value: '+46' },
        { text: '+41', value: '+41' },
        { text: '+992', value: '+992' },
        { text: '+66', value: '+66' },
        { text: '+228', value: '+228' },
        { text: '+690', value: '+690' },
        { text: '+676', value: '+676' },
        { text: '+1 868', value: '+1 868' },
        { text: '+216', value: '+216' },
        { text: '+90', value: '+90' },
        { text: '+993', value: '+993' },
        { text: '+1 649', value: '+1 649' },
        { text: '+688', value: '+688' },
        { text: '+256', value: '+256' },
        { text: '+380', value: '+380' },
        { text: '+971', value: '+971' },
        { text: '+44', value: '+44' },
        { text: '+598', value: '+598' },
        { text: '+998', value: '+998' },
        { text: '+678', value: '+678' },
        { text: '+681', value: '+681' },
        { text: '+967', value: '+967' },
        { text: '+260', value: '+260' },
        { text: '+263', value: '+263' },
        { text: '+591', value: '+591' },
        { text: '+673', value: '+673' },
        { text: '+243', value: '+243' },
        { text: '+225', value: '+225' },
        { text: '+500', value: '+500' },
        { text: '+379', value: '+379' },
        { text: '+852', value: '+852' },
        { text: '+98', value: '+98' },
        { text: '+850', value: '+850' },
        { text: '+82', value: '+82' },
        { text: '+856', value: '+856' },
        { text: '+218', value: '+218' },
        { text: '+853', value: '+853' },
        { text: '+389', value: '+389' },
        { text: '+691', value: '+691' },
        { text: '+373', value: '+373' },
        { text: '+258', value: '+258' },
        { text: '+970', value: '+970' },
        { text: '+872', value: '+872' },
        { text: '+7', value: '+7' },
        { text: '+590', value: '+590' },
        { text: '+290', value: '+290' },
        { text: '+1 869', value: '+1 869' },
        { text: '+1 758', value: '+1 758' },
        { text: '+508', value: '+508' },
        { text: '+1 784', value: '+1 784' },
        { text: '+239', value: '+239' },
        { text: '+252', value: '+252' },
        { text: '+963', value: '+963' },
        { text: '+886', value: '+886' },
        { text: '+255', value: '+255' },
        { text: '+670', value: '+670' },
        { text: '+58', value: '+58' },
        { text: '+1 284', value: '+1 284' },
        { text: '+1 340', value: '+1 340' },
        { text: '+84', value: '+84' },
    ],
    orderStatus: [
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 1 },
        { value: 5, name: 'Đã mua hàng', color: '#2bbae4', orderIndex: 4 },
        { value: 8, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 7 },
        { value: 0, name: 'Chờ đặt cọc', color: 'red', orderIndex: 2 },
        { value: 16, name: 'Đang vận chuyển', color: '#f7819f', orderIndex: 5 },
        { value: 9, name: 'Đã thanh toán', color: 'blue', orderIndex: 8 },
        { value: 2, name: 'Đã đặt cọc', color: 'green', orderIndex: 3 },
        { value: 7, name: 'Đã nhập kho', color: 'orange', orderIndex: 6 },
        { value: 13, name: 'Khiếu nại', title: 'Đã khiếu nại', color: '#9732f3', orderIndex: 9 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 10 },
    ],
    depositStatus: [
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 1 },
        { value: 16, name: 'Đang vận chuyển', color: '#f7819f', orderIndex: 2 },
        { value: 8, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 4 },
        { value: 7, name: 'Đã nhập kho', color: 'orange', orderIndex: 3 },
        { value: 9, name: 'Đã thanh toán', color: 'blue', orderIndex: 5 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 6 },
    ],
    paymentTypeList: [
        { value: 1, name: 'Trực tiếp', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Ví', color: '#0059b3', textColor: '#FFF' },
    ],
    paymentStatusList: [
        { value: 2, name: 'Đặt cọc', color: '#808080', textColor: '#000' },
        { value: 12, name: 'Nhận lại cọc', color: '#e63900', textColor: '#000' },
        { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
        { value: 10, name: 'Thanh toán ship', color: '#7a8498', textColor: '#FFF' },
    ],
    complainStatusList: [
        { value: 0, name: 'Đã hủy', color: 'black' },
        { value: 1, name: 'Chờ xử lý', color: 'red' },
        { value: 2, name: 'Đang xử lý', color: 'orange' },
        { value: 3, name: 'Đã xử lý', color: 'blue' },
    ],
    statusAction: [
        { text: 'Hủy đơn hàng', color: '#d9534f', orderStatus: [0, 2] },
        { text: 'Khiếu nại', color: '#9732f3', orderStatus: [9, 13] },
    ],
    statusRecharge: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' },
        { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
        { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
    ],
    statusWithdrawal: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
    ],
    walletTradeType: [
        { value: 1, name: 'Đặt cọc' },
        { value: 2, name: 'Nhận lại tiền đặt cọc' },
        { value: 3, name: 'Thanh toán hóa đơn' },
        { value: 4, name: 'Nạp tiền' },
        { value: 5, name: 'Rút tiền' },
        { value: 6, name: 'Hủy lệnh rút tiền' },
        { value: 7, name: 'Xử lý khiếu nại' }
    ],
    billOfLadingStatus: [
        { value: 1, name: 'Đang vận chuyển', disabled: false, color: '#f7819f', textColor: '#FFF' },
        { value: 2, name: 'Đang vận chuyển', disabled: false, color: '#f7819f', textColor: '#FFF' },
        { value: 3, name: 'Đã nhập kho', disabled: false, color: 'orange', textColor: '#FFF' },
        { value: 4, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' }
    ],
    receiptStatus: [
        { value: 1, name: 'Chưa xuất'},
        { value: 2, name: 'Đã xuất' },
        { value: 3, name: 'Đã thanh toán' }
    ],
    feeTypes: [
        { value: 1, name: 'Cân nặng', color: '#2EBB32' },
        { value: 2, name: 'Thể tích', color: '#dc3545' }
    ],
    paymentMethods: [
        { value: 1, name: 'Ví'},
        { value: 2, name: 'Tiền mặt'},
        { value: 3, name: 'COD'},
    ],
    requestPaymentStatus: [
        { value: 1, name: 'Đang xử lý', color: '#f7819f', textColor: '#FFF'},
        { value: 2, name: 'Đã xử lý', color: 'orange', textColor: '#FFF' },
    ],
    payserviceStatus: [
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 1 },
        { value: 2, name: 'Chờ báo giá', color: '#f7819f', orderIndex: 2 },
        { value: 3, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 3 },
        { value: 4, name: 'Đã thanh toán', color: 'orange', orderIndex: 4 },
        { value: 5, name: 'Hoàn thành', color: '#7a8498', orderIndex: 5 },
    ],
};
